"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var KeyboardVoice_exports = {};
__export(KeyboardVoice_exports, {
  default: () => KeyboardVoice_default
});
module.exports = __toCommonJS(KeyboardVoice_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.03906 5.13281C8.03906 4.44271 8.27995 3.86328 8.76172 3.39453C9.24349 2.91276 9.82292 2.67188 10.5 2.67188C11.1771 2.67188 11.7565 2.91276 12.2383 3.39453C12.7201 3.86328 12.9609 4.44271 12.9609 5.13281V9.78125C12.9609 10.4583 12.7201 11.0378 12.2383 11.5195C11.7565 11.9883 11.1771 12.2227 10.5 12.2227C9.82292 12.2227 9.24349 11.9883 8.76172 11.5195C8.27995 11.0378 8.03906 10.4583 8.03906 9.78125V5.13281ZM5.5 9.01953C5.64323 9.01953 5.76042 9.07161 5.85156 9.17578C5.95573 9.26693 6.00781 9.3776 6.00781 9.50781C6.00781 9.63802 6.00781 9.76823 6.00781 9.89844C6.02083 10.0156 6.04036 10.1393 6.06641 10.2695C6.15755 10.7904 6.33333 11.2786 6.59375 11.7344C6.85417 12.2031 7.17969 12.6068 7.57031 12.9453C7.97396 13.2708 8.42318 13.5312 8.91797 13.7266C9.41276 13.9089 9.9401 14 10.5 14C11.0599 14 11.5872 13.9089 12.082 13.7266C12.5768 13.5312 13.0195 13.2708 13.4102 12.9453C13.8008 12.6068 14.1328 12.2031 14.4062 11.7344C14.6667 11.2786 14.8424 10.7904 14.9336 10.2695C14.9466 10.1393 14.9596 10.0156 14.9727 9.89844C14.9857 9.76823 14.9922 9.63802 14.9922 9.50781C14.9922 9.3776 15.0378 9.26693 15.1289 9.17578C15.2331 9.07161 15.3568 9.01953 15.5 9.01953C15.6302 9.01953 15.7409 9.07161 15.832 9.17578C15.9362 9.26693 15.9883 9.3776 15.9883 9.50781C15.9883 9.66406 15.9818 9.82031 15.9688 9.97656C15.9557 10.1328 15.9362 10.2826 15.9102 10.4258C15.806 11.0378 15.6107 11.6107 15.3242 12.1445C15.0378 12.6654 14.6732 13.1276 14.2305 13.5312C13.8008 13.9349 13.3125 14.2669 12.7656 14.5273C12.2057 14.7747 11.6133 14.9245 10.9883 14.9766V17.3008C10.9883 17.444 10.9362 17.5677 10.832 17.6719C10.7409 17.763 10.6302 17.8086 10.5 17.8086C10.3568 17.8086 10.2331 17.763 10.1289 17.6719C10.0378 17.5677 9.99219 17.444 9.99219 17.3008V14.9766C9.36719 14.9245 8.78125 14.7747 8.23438 14.5273C7.67448 14.2669 7.17969 13.9349 6.75 13.5312C6.32031 13.1276 5.96224 12.6654 5.67578 12.1445C5.3763 11.6107 5.17448 11.0378 5.07031 10.4258C5.04427 10.2826 5.02474 10.1328 5.01172 9.97656C4.9987 9.82031 4.99219 9.66406 4.99219 9.50781C4.99219 9.3776 5.03776 9.26693 5.12891 9.17578C5.23307 9.07161 5.35677 9.01953 5.5 9.01953Z",
      fill: "currentColor"
    }
  )
);
const SvgKeyboardVoice = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var KeyboardVoice_default = SvgKeyboardVoice;
